import React from "react";
import Slider1 from "./Slider1";
import Trend from "./Trend";
import PopularMov from "./PopularMov";
import NowPlay from "./NowPlaying";
import TopRate from "./TopRate";

const Dashboard = () => (
  <div>
    <Slider1 />
    <Trend />
    <NowPlay />
    <TopRate />
    <PopularMov />
  </div>
);

export default Dashboard;
